(function () {
    'use strict';

    /**
     * Custom filters for the ChilliDocs application
     */

    /**
     *
     * Formats the supplied file size into an appropriate format for user display.
     */
    angular.module('app').filter('formatFileSize', function () {
        return function (item) {
            var result = '';

            if (item < 1024) {
                result = item + ' bytes';
            } else if (item < (1024 * 1024)) {
                result = Math.floor(item / 1024) + ' KB';
            } else {
                result = Math.floor(item / (1024 * 1024)) + ' MB';
            }

            return result;
        };
    });

    /**
     *
     * Formats the supplied string in Start Case format.
     */
    angular.module('app').filter('startCase', function () {
        return function (item) {
            return _.startCase(item);
        };
    });
})();